import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.css'
})
export class ConfirmModalComponent {
  @Input() title: string = 'Bevestigen';
  @Input() message: string = 'Weet je het zeker?';
  @Input() confirmText: string = 'Ja';
  @Input() cancelText: string = 'Annuleren';

  private activeModal = inject(NgbActiveModal);

  confirm() {
    this.activeModal.close(true);
  }

  cancel() {
    this.activeModal.dismiss(false);
  }
}
